import { useNavbarLayout } from '@workwhile/web-ui'
import { CompanyHeader } from './CompanyHeader'
import { CompanySwitcher } from './CompanySwitcher'

export const CompanyInfo = () => {
  const layout = useNavbarLayout()

  return (
    <>
      {/* web-ui hides this on phones */}
      <CompanyHeader />
      {layout === 'closed' ? null : <CompanySwitcher />}
    </>
  )
}
